import type {
  ApplicationFileAttachment,
  OtherSource,
  ResidentApplicationData,
} from '@/types/application'

/** Other income sources — API may use resident_other_source or other_source */
export function getResidentOtherSources(
  data: ResidentApplicationData | null | undefined
): OtherSource[] {
  if (!data) return []
  return data.resident_other_source ?? data.other_source ?? []
}

export function isBankAlreadyLinked(
  data: ResidentApplicationData | null | undefined
): boolean {
  if (!data?.bank_already_link) return false
  const flag = data.bank_already_link
  return flag === true || flag === 1 || flag === '1'
}

/** Normalize government ID attachment field (object or array) to array */
export function normalizeGovIdAttachments(
  attachment:
    | ApplicationFileAttachment
    | ApplicationFileAttachment[]
    | null
    | undefined
): ApplicationFileAttachment[] {
  if (!attachment) return []
  return Array.isArray(attachment)
    ? attachment
    : attachment.attachment_id
      ? [attachment]
      : []
}

export function getAttachmentFileName(file: ApplicationFileAttachment): string {
  return file.filename || file.name || 'file'
}
